import React from "react"
import FormWrapper from "./FormWrapper"

export default function Add() {
  return (
    <div className="container">
      <h1>Add User</h1>
      <FormWrapper type="add" />
    </div>
  )
}
